import { render, staticRenderFns } from "./GridBoolean.vue?vue&type=template&id=a478ca28"
import script from "./GridBoolean.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridBoolean.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports